// extracted by mini-css-extract-plugin
module.exports = {"listD":"listD_listD__YYP4s"};